import { ar } from "./dictionary.ar";
import { balootEn } from "./dictionary.baloot";
import { cardEn } from "./dictionary.card";
import { heartsEn } from "./dictionary.hearts";
import { homeEn } from "./dictionary.home";
import { kingEn } from "./dictionary.king";
import { languageEn } from "./dictionary.language";
import { matchEn } from "./dictionary.match";
import { pistiEn } from "./dictionary.pisti";
import { rulesEn } from "./dictionary.rules";
import { socialEn } from "./dictionary.social";
import { spadesEn } from "./dictionary.spades";
import { tablesEn } from "./dictionary.tables";
import { tr } from "./dictionary.tr";

/** Every user-visible string. Keys are stable; languages must cover the same keys (tested). */
export const en = {
  ...matchEn,
  ...balootEn,
  ...spadesEn,
  ...cardEn,
  ...languageEn,
  ...socialEn,
  ...rulesEn,
  ...heartsEn,
  ...homeEn,
  ...kingEn,
  ...pistiEn,
  ...tablesEn,
  "app.name": "High Card Club",
  "table.bar.trump": "Trump {suit}",
  "table.bar.trumpLabel": "Trump",
  "table.bar.targetLabel": "To",
  "table.bar.handsLabel": "Hands",
  "table.turn.you": "Your turn",
  "table.turn.play": "Your turn · play",
  "table.turn.other": "{name} is playing",
  "table.turn.bidding": "{name} is bidding",
  "table.turn.trump": "{name} picks the trump",
  "table.bid.you": "You are bidding",
  "table.trump.forHand": "for {amount} tricks",
  "table.trump.inHand": "{count} in hand",
  "table.seat.pass": "Pass",
  "table.seat.thinking": "Thinking…",
  "table.seat.waiting": "Waiting",
  "table.seat.score": "{score} points",
  "table.seat.away": "Away · bot plays",
  "table.seat.hand": "{count} {count|card|cards} in hand",
  "table.trick.led": "{name} led",
  "table.handEnd.title": "Hand over",
  "table.event.redeal": "Everyone passed: new deal",
  "table.event.contract-forced": "Everyone passed: {name} plays {amount}",
  "table.event.trump-chosen": "Trump is {suit}",
  "lobby.seated": "{count} / 4 seated",
  "lobby.ready": "Ready",
  "lobby.empty": "Empty seat",
  "lobby.watchers": "{count} watching",
  "tooltip.invite": "Invite a friend",
  "tooltip.sound": "Sound volume",
  "home.scene": "Scene",
  "scene.orman": "Forest",
  "scene.otel": "Hotel",
  "scene.uzay": "Space",
  "scene.istanbul": "Istanbul",
  "scene.majlis": "Majlis",
  "scene.neon": "Neon",
  "data.open": "{name} - my data",
  "data.title": "My data",
  "data.back": "Back",
  "data.failed": "That did not work. Try again in a moment.",
  "data.legal": "Legal",
  "data.leaderboard": "Leaderboard",
  "data.hide": "Hide my name on the leaderboard",
  "data.hide.about":
    'Your matches still count. Others see "Hidden player" instead of your name and picture.',
  "data.usage": "Usage measurement",
  "data.measure": "Take part in usage measurement",
  "data.measure.about":
    "We count the days you open the game, sit down and finish matches, and nothing else. Turn it off and these records are deleted and no new ones are kept.",
  "data.download": "A copy of your data",
  "data.download.about":
    "A link opens in your browser with a JSON file of everything we keep about you. It works once, for ten minutes.",
  "data.download.start": "Download my data",
  "data.delete": "Deletion",
  "data.delete.about":
    "We wait 30 days, then your matches are anonymised and everything else is deleted. You can cancel until then.",
  "data.delete.start": "Delete my data",
  "data.delete.confirm":
    'In 30 days your matches stay only as "Deleted player" for your opponents, and your trials, Club notifications and settings are removed. This cannot be undone after that day.',
  "data.delete.yes": "Delete in 30 days",
  "data.delete.keep": "Keep my data",
  "data.delete.pending": "Your data will be deleted on {date}.",
  "data.delete.cancel": "Cancel deletion",
  "legal.privacy": "Privacy policy",
  "legal.terms": "Terms of use",
  "legal.notice": "By playing you accept the",
  "legal.dismiss": "Close",
  "leaderboard.hiddenPlayer": "Hidden player",
  "home.deck": "Deck",
  "deck.classic": "Classic",
  "deck.anime": "Anime",
  "deck.obsidian": "Obsidian",
  "club.badge": "Club",
  "club.new": "New",
  "club.trialOffer": "Free for 3 days",
  "club.starting": "Starting…",
  "club.left.days": "Free · {count} {count|day|days} left",
  "club.left.hours": "Free · {count} {count|hour|hours} left",
  "club.left.minutes": "Free · {count} min left",
  "club.locked": "Coming back with Club",
  "club.notify": "Tell me",
  "club.notified": "We'll tell you",
  "club.ended.deck": "Your {name} deck trial is over. It comes back with Club.",
  "club.ended.scene": "Your {name} scene trial is over. It comes back with Club.",
  "invite.copied": "Link copied",
  "invite.copiedSub": "Send it to a friend to come straight to the table.",
  "table.bar.noTrump": "No trump",
  "table.seat.chooseTrump": "bid {amount} · pick trump",
  "table.bid.canSay": "{name} bid {amount} · you can say {min}+",
  "table.bid.open": "No bid yet · you can say {min}+",
  "table.bid.note": "If everyone passes, the first to speak plays 4",
  "table.toast.points": "{points} points",
  "table.toast.down": "DOWN · {points} points",
  "table.toast.won": "You took the bid at {amount}",
  "table.toast.pickTrump": "now pick your trump",
  "table.toast.forced": "Everyone passed: you play {amount}",
  "table.gameEnd.meta": "{hands} {hands|hand|hands} · {target}",
  "table.watching.sub": "· a seat opens when the match ends",
  "table.connecting.sub": "Your seat is kept; a bot plays for you until you are back.",
  "table.leaving": "Leaving the table…",
  "auth.connecting": "Connecting to Discord…",
  "auth.denied": "High Card Club needs permission to see who you are.",
  "auth.server": "The table server did not answer.",
  "auth.refresh": "A new version is ready. Reopen the activity.",
  "auth.retry": "Try again",
  "update.title": "A new version is ready",
  "update.body": "Reload to keep playing. If you were in a match, your seat is waiting for you.",
  "update.reload": "Reload",
  "lobby.title": "Lobby",
  "lobby.seat.empty": "Sit",
  "lobby.seat.bot": "Bot",
  "lobby.seat.away": "Away",
  "lobby.settings": "{variant} · {target} · {tempo}",
  "lobby.target.goal": "first to {goal}",
  "lobby.target.length": "{length} {length|hand|hands}",
  "lobby.fillBots": "Fill with bots",
  "lobby.start": "Start now",
  "lobby.countdown": "Starting in {seconds}",
  "home.title": "Pick a game",
  "home.subtitle": "This channel gets one table; whoever opens it picks the game.",
  "home.open": "Open the table",
  "home.goal": "Play to",
  "home.hands": "Hands",
  "home.tempo": "Tempo",
  "home.points": "{goal} points",
  "home.handsCount": "{length} {length|hand|hands}",
  "lobby.share.message": "Join my table at High Card Club",
  "lobby.leaveTable": "Back to my channel",
  "profile.loading": "Loading your record…",
  "profile.none": "No matches yet. Open a table.",
  "profile.record": "{matches} {matches|match|matches} · {wins} {wins|win|wins}",
  "home.heading": "Lobby",
  "home.tab.create": "Set up a table",
  "home.tab.join": "Join a table",
  "home.quick": "Find players: {game}",
  "home.rules": "House rules",
  "rule.spades.bagPenalty": "Bag penalty",
  "rule.spades.bagPenalty.true": "10 bags = −100",
  "rule.spades.bagPenalty.false": "No penalty",
  "rule.tarneeb.trumpLead": "Leading trump",
  "rule.tarneeb.trumpLead.false": "Anytime",
  "rule.tarneeb.trumpLead.true": "Only once broken",
  "rule.tarneeb.minBid": "Opening bid",
  "rule.tarneeb.minBid.7": "7",
  "rule.tarneeb.minBid.5": "5",
  "home.who": "Who can join",
  "home.who.anyone": "Anyone",
  "home.who.invite": "Invite only",
  "lobby.game": "Game",
  "lobby.target.points": "to {goal} points",
  "table.event.contract-won": "{name} took the bid at {amount}",
  "rule.baloot.projects": "Projects",
  "rule.baloot.projects.true": "Sira, 50, 100, 400",
  "rule.baloot.projects.false": "None",
  "rule.baloot.doubling": "Doubling",
  "rule.baloot.doubling.true": "Double to gahwa",
  "rule.baloot.doubling.false": "None",
  "tempo.relaxed": "Relaxed",
  "tempo.normal": "Normal",
  "tempo.fast": "Fast",
  "table.bar.hand": "Hand {hand}",
  "table.bar.goal": "to {goal}",
  "table.bar.length": "of {length}",
  "table.seat.tricks": "{tricks} {tricks|trick|tricks}",
  "table.seat.bid": "bid {amount}",
  "table.seat.turn": "Turn",
  "table.bid.title": "Your bid",
  "table.bid.pass": "Pass",
  "table.trump.title": "Choose trump",
  "table.hand.title": "Your hand",
  "table.watching": "You are watching",
  "table.handEnd.made": "{name} bid {amount} and made it",
  "table.handEnd.failed": "{name} bid {amount} and went down",
  "table.gameEnd.title": "Match over",
  "table.gameEnd.winner": "Winner: {names}",
  "table.again": "Play again",
  "table.leave": "Leave table",
  "table.trick.winner": "{name} takes the trick",
  "table.connecting": "Reconnecting…",
  "suit.spades": "Spades",
  "suit.hearts": "Hearts",
  "suit.diamonds": "Diamonds",
  "suit.clubs": "Clubs",
  "error.seat-taken": "That seat was just taken.",
  "error.kicked": "The table owner removed you. You can still watch.",
  "error.not-owner": "Only the table owner can do that.",
  "error.not-lobby": "The game has already started.",
  "error.look-locked": "That one is locked; the table keeps its default.",
  "error.spectators-full": "The table is full of spectators.",
  "error.generic": "Something went wrong ({code}).",
  "error.boundary": "Something broke on our side. Reload the activity.",
  "error.eventId": "Event id: {id}",
  "error.reload": "Reload",
  "home.leaderboard": "Leaderboard",
  "leaderboard.title": "Leaderboard",
  "leaderboard.back": "Back",
  "leaderboard.periods": "Period",
  "leaderboard.period.week": "Week",
  "leaderboard.period.month": "Month",
  "leaderboard.period.all": "All time",
  "leaderboard.heading.week": "Weekly ranking",
  "leaderboard.heading.month": "Monthly ranking",
  "leaderboard.heading.all": "All-time ranking",
  "leaderboard.left.days": "{days} {days|day|days} {hours} {hours|hour|hours} left",
  "leaderboard.left.hours": "{hours} {hours|hour|hours} left",
  "leaderboard.left.soon": "less than an hour left",
  "leaderboard.record": "{wins}-{losses}",
  "leaderboard.recordName": "{wins} {wins|win|wins}, {losses} {losses|loss|losses}",
  "leaderboard.you": "Your rank",
  "leaderboard.who": "Who counts",
  "leaderboard.scope.all": "Everyone",
  "leaderboard.scope.guild": "My server",
  "leaderboard.emptyGuild":
    "Nobody from your server is ranked yet. Only tables of four players count; matches with bots do not.",
  "leaderboard.unranked": "Not ranked yet: play a table of four players",
  "leaderboard.empty":
    "No ranked matches yet. Only tables of four players count; matches with bots do not.",
  "leaderboard.loading": "Loading the ranking…",
  "leaderboard.error": "The ranking did not load.",
  "leaderboard.retry": "Try again",
  "leaderboard.trend.new": "new",
  "leaderboard.trend.up": "up {n}",
  "leaderboard.trend.down": "down {n}",
  "leaderboard.trend.same": "no change",
} as const;

export type Key = keyof typeof en;

export { ar, tr };

export const dictionaries = { en, tr, ar } as const;
export type Locale = keyof typeof dictionaries;
